import { Component, Input, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController } from 'ionic-angular';
import { CajaProvider } from '../../providers/caja/caja';
import { FormasDePagoPage } from '../formasdepago/formasdepago';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'page-personalizar',
  templateUrl: 'personalizar.html',
  providers: [ CajaProvider ]
})

export class PersonalizarPage   implements OnInit {
  productos: any[] = [];
  selected: number[] = [];
  numeros: number[] = Array.from({ length: 20 }, (_, i) => i + 1);
  totals: { [key: number]: number } = {};
  groupedProducts: { [key: number]: any[] } = {};
  valorTotalVenta:number = 0;
  @Input() listaProductosSeleccionados: any[] = [];
  @Input() valorTotalVentaDesdeGestion: number = 0;
  @Input() CheckPorcentajeServicio:any = false
  @Input() turnosArray:any = []
  @Input() mesaSeleccionada:any = ''
  deseaImprimir: boolean = false
  valorTotal: number = 0;
  formasDePago: FormaPago[] = [];
  formasDePagoGeneral: FormaPago[] = []
  visualizarFormaDePagoGeneral: boolean= true
  formaDePagosFiltrada:any = []
  valorPago: { [key: string]: string | number } = {};
  devolver: number = 0;
  devolucion: number = 0;
  valorTurno = 0
  datosAdicionales:any
  dividirCuenta:boolean = false
  formasDePagoSeGenero:boolean = false
  // Definir la propiedad totalConDescuento como un objeto para cada grupo
  // totalConDescuento: { [key: number]: number } = {};
  totalConDescuento: { [key: string]: string | number } = {};
  // Definir la propiedad descuento para guardar el porcentaje de descuento por grupo
  // descuento: { [key: number]: number } = {};
  descuento: { [key: string]: string | number } = {};
  // Variables para manejar la propina
  deseaPropina: { [key: string]: string } = {};
  tipoPropina: { [key: string]: string } = {};
  propinaPorcentaje: { [key: string]: number } = {};
  propinaValor: { [key: string]: number } = {};
  totalConPropina: { [key: string]: number } = {};
  private actualizandoTotal: boolean = false; // Bandera para evitar ciclo infinito
  constructor(public modalControllers: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public servicio: CajaProvider,
    public utils:UtilsProvider,
  ) { }
  ngOnInit() {
    this.cargarFormasDePago()
    this.productos = this.navParams.get('listaProductosSeleccionados')
    this.valorTotalVenta = this.navParams.get('valorTotalVenta')
    this.valorTurno = this.navParams.get('valorTurno')
    this.datosAdicionales = this.navParams.get('datosAdicionales')
    let companiasId = this.navParams.get('companiasId')
    this.deseaImprimir = this.navParams.get('deseaImprimir')
    this.calcularValorTotalVenta()
    this.traerIdDelTurno(this.valorTurno.toString(), companiasId)
  }
  ionViewDidLoad() {
    const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    element.style.height = '100%';
    element.style.width = '100%';
    element.style.top = '0';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';
  }
  calcularValorTotalVenta(){
    let totalVenta = this.productos.reduce((total, producto) => {
      return total + (producto.valorVenta * producto.cantidad);
  }, 0);
  this.valorTotalVenta = totalVenta
}

  procesarSeleccion(seGenero:boolean = false) {
    this.dividirCuenta = seGenero
    this.groupedProducts = this.groupProductsBySelection(this.productos, this.selected);
    this.totals = {};
    const keys = Object.keys(this.groupedProducts);
    for (const key of keys) {
      const products = this.groupedProducts[key];
      const total = products.reduce((sum, product) => sum + (product.valorVenta * product.cantidad), 0);
      this.totals[Number(key)] = total;
    }

    this.selected.forEach(group => {

      if (this.totals[group] == undefined) {
        this.totals[group] = 0; // Establece el total como 0 si el grupo no tiene productos
      }
    });
    this.visualizarFormaDePagoGeneral = false;
  }

  async cargarFormasDePago() {
    const companiasId = localStorage.getItem('companiasId');
    const respuestaFormasDePago:any = await this.servicio.buscarFormasDePago(companiasId);
    let formasDePagos:any = []
    let respuestaFormasDePagoJson =  respuestaFormasDePago.json()

    if (respuestaFormasDePagoJson  && respuestaFormasDePagoJson.data && respuestaFormasDePagoJson.data.length > 0) {
      formasDePagos = respuestaFormasDePagoJson.data[0];
    } else {
        formasDePagos = [];
    }
    const totalValorVenta = this.productos.reduce((total: any, producto:any) => total + producto.valorVenta * producto.cantidad, 0);
    this.valorTotal = totalValorVenta;
    this.formasDePago = formasDePagos
  }

  adjustTotals() {
    // Identificar el valor asociado a NaN
    const nanValue = this.totals[NaN];

    // Reasignar el valor de NaN a la clave deseada, por ejemplo, 0
    if (nanValue !== undefined) {
      this.totals[0] = nanValue; // Asignar el valor de NaN a la clave 0
      delete this.totals[NaN]; // Eliminar la clave NaN
    }
  }

  groupProductsBySelection(productos: any[], selected: number[]): { [key: number]: any[] } {
    const groupedProducts: { [key: number]: any[] } = {};

    productos.forEach((producto, index) => {
      const selectionNumber = selected[index]; // Obtén el número de selección correspondiente al índice del producto
      if (!groupedProducts[selectionNumber]) {  // Si el grupo no existe, créalo
        groupedProducts[selectionNumber] = [];
      }
      const productoConNumeroDeSeleccion = { ...producto, numeroPersona: selectionNumber }; // Agrega el numeroDeSeleccion al producto
      groupedProducts[selectionNumber].push(productoConNumeroDeSeleccion); // Agrega el producto al grupo correspondiente
    });

    return groupedProducts; // Devuelve el objeto con productos agrupados
  }

  objectKeys(obj: { [key: number]: any[] }): number[] {
    return Object.keys(obj).map(key => +key);
  }

  isNumber(value: any): boolean {
    return !isNaN(Number(value));
  }

  async gestionarFormasDePago(productos:any, persona:any,seGenero:boolean = false, descuento:any=0,group:any=0) {
    try {
      this.formasDePagoSeGenero = seGenero
      const companiasId = localStorage.getItem('companiasId');
      const respuestaFormasDePago:any = await this.servicio.buscarFormasDePago(companiasId);
      let formasDePagos:any = []
      if (respuestaFormasDePago && respuestaFormasDePago._body) {
        const parsedBody = JSON.parse(respuestaFormasDePago._body);
        if (parsedBody.data && Array.isArray(parsedBody.data) && parsedBody.data.length > 0) {
          formasDePagos = parsedBody.data[0];
        } else {
          formasDePagos = [];
        }
      } else {
        formasDePagos = [];
      }
      let losProductos:any = []
      if(persona !== 30) {
        if(isNaN(persona)) {
          persona = "27"
          if (productos.hasOwnProperty("undefined")) {
            // Mueve los datos de "undefined" a la clave 30
            productos["27"] = productos["undefined"];
            // Elimina la clave "undefined"
            delete productos["undefined"];
          }
        }
        const productosFiltrados = productos[persona];
        losProductos = productosFiltrados
      } else {
        losProductos = productos
      }
      let totalValorVenta = losProductos.reduce((total: any, producto: any) => {
        // Verificamos si 'valorConDescuento' existe y es un valor válido
        const valorConDescuento = producto.valorConDescuento;

        // Si 'valorConDescuento' es un valor numérico válido y mayor que 0, lo sumamos
        if (typeof valorConDescuento === 'number' && !isNaN(valorConDescuento) && valorConDescuento > 0) {
            return total + valorConDescuento;  // Sumar 'valorConDescuento'
        } else {
            // Si no existe o es 0, sumamos el valor original
            return total + (producto.valorVenta * producto.cantidad);  // Sumar 'valorVenta * cantidad'
        }
      }, 0);  // El valor inicial del total es 0

      const groupKeys = Object.keys(this.tipoPropina); // Obtener las llaves disponibles en tipoPropina
      const validGroup = groupKeys.find(g => g === '0' || g === '1'); // Verificar si existe la posición 0 o 1

      if (validGroup && this.deseaPropina[validGroup] === 'si') {
          let propina = 0;

          if (this.tipoPropina[validGroup] === 'porcentaje' && this.propinaPorcentaje[validGroup]) {
              propina = (totalValorVenta * (this.propinaPorcentaje[validGroup] / 100));
          } else if (this.tipoPropina[validGroup] === 'valor' && this.propinaValor[validGroup]) {
              propina = this.propinaValor[validGroup];
          }

          totalValorVenta += Number(propina);
      }

      const modal = this.modalControllers.create(
        FormasDePagoPage,
         {
          'valorTotal': totalValorVenta,
          'formasDePago': formasDePagos,
          'visualizarAtras':true
        }, {
          cssClass: 'fullscreen-modal',
          enableBackdropDismiss: true
        });

      modal.present();

      modal.onDidDismiss((detail: any) => {
        if (detail !== null) {
          let data:any = detail
          if (data && data.formaDePagos !== undefined &&  this.listaProductosSeleccionados) {
            let formaDePagosPersona = data.formaDePagos.map((formaDePago: any) => {
              return {
                persona: persona == undefined ? '27' : persona,
                ...formaDePago
              };
            });
            if(formaDePagosPersona[0] !== undefined) {
              this.formasDePagoGeneral.push(formaDePagosPersona)
            }
            this.formaDePagosFiltrada[persona] = formaDePagosPersona;
            if(this.formasDePago.length>0 && losProductos.length>0){
                this.listaProductosSeleccionados = this.listaProductosSeleccionados.map((item: any) => {
                return {
                  ...item,
                  formaDePago: losProductos[0].productosId === item.productosId ?  data.formaDePagos : [],
                  numeroPersona: losProductos[0].productosId === item.productosId ?  "0" : losProductos[0].numeroPersona,
                };
              });
            }
          }
        }
      })
      // return await modal.present();
    } catch (error) {
      console.error('Error:', error);
    }
  }

  incluirServicio(productos:any) {

  }

  aplicarDescuento(productos:any) {

  }

  cerrarModal() {
    this.viewCtrl.dismiss({
      groupedProducts: this.groupedProducts,
      totals: this.totals,
      productos: this.productos,
      formasDePago: this.formasDePagoGeneral,
      deDondeViene: undefined,
      dividirCuenta:this.dividirCuenta,
      formasDePagoSeGenero:this.formasDePagoSeGenero
    });
  }

  formatNumber(event: any, group: string): void {
    const inputValue = parseFloat(event.target.value.replace(/,/g, '')) || 0;
    this.valorPago[group] = inputValue.toLocaleString(); // Actualizar el valor con el formato adecuado
  }

  aplicarDescuentoIndividual(group: string, productoSeleccionado: any): void {
    const porcentajeDescuento = Number(this.descuento[group]) || 0; // Aseguramos que sea un número
   const productoSeleccionadoUnicoRegistro = this.filtrarProductosPorGrupo(productoSeleccionado,group)
    this.valorTotalVenta = 0


    let nuevoValor = 0
    // Actualizamos solo el producto específico en `this.productos` (la lista completa de productos)
    this.productos.forEach(producto => {
      // Verificamos si el producto es el seleccionado y pertenece al grupo adecuado
      if (producto.productosId == productoSeleccionadoUnicoRegistro[0].productosId) {
        producto.porcentajeDescuento = porcentajeDescuento;
        producto.valorConDescuento = (producto.valorVenta * producto.cantidad) * (1 - porcentajeDescuento / 100);
        // Solo agregamos el valor de los productos que NO están en los grupos ya descontados
        nuevoValor += producto.valorConDescuento  // Si tiene descuento, usamos el valor con descuento
        // this.totalConDescuento[group] = producto.valorConDescuento;

      } else {
        nuevoValor += (producto.valorVenta * producto.cantidad);
      }
    });

      // Actualizar el valor total de la venta
      this.valorTotalVenta = nuevoValor;
      this.calcularDescuentoPorGrupo()
  }


filtrarProductosPorGrupo(productoSeleccionado, group) {
  // Validar si 'group' es undefined o NaN
  if (group === undefined || isNaN(group)) {
    let nuevosProducotsSeleccion = productoSeleccionado["undefined"] || [];
    let productos = []
    productos.push(nuevosProducotsSeleccion)
    return productos
  }

  // Si 'group' tiene un valor válido, devolver el grupo correspondiente o un array vacío
  return productoSeleccionado[group] || [];
}

calcularDescuentoPorGrupo(): void {
  let totalVenta = 0; // Variable para almacenar el total de la venta

  // Recorremos todos los grupos de productos
  for (const group in this.groupedProducts) {
    const productosGrupo = this.groupedProducts[group];
    let totalDescuentoGrupo = 0; // Variable para acumular el descuento del grupo

    // Recorremos los productos del grupo
    productosGrupo.forEach(producto => {
      const porcentajeDescuento = Number(this.descuento[group]) || 0; // Si no hay descuento, usamos 0
      const valorConDescuento = (producto.valorVenta * producto.cantidad) * (1 - porcentajeDescuento / 100);

      totalDescuentoGrupo += valorConDescuento;
      producto.porcentajeDescuento = porcentajeDescuento;
      producto.valorConDescuento = valorConDescuento; // Guardamos el valor con descuento en el producto
    });

    // Guardamos el total con descuento para el grupo
    this.totalConDescuento[group] = totalDescuentoGrupo;
    // Sumamos el total con propina al total de la venta
    totalVenta += Number(this.totalConPropina[group]) || totalDescuentoGrupo; // Si no hay propina, usa el total con descuento
  }

  // Asignamos el total acumulado
  this.valorTotalVenta = totalVenta;

  // Ahora sí, actualizamos la propina correctamente después de calcular descuentos
  for (const group in this.groupedProducts) {
    this.calcularTotalConPropina(group, this.tipoPropina[group]);
  }
}



  // Función para manejar el click en el botón "Pagar"
  pagar(group:string, producto:any,devolver:any, descuento:any
    , tipoPropina: string, propinaValor: number, propinaPorcentaje: number,
    totalConPropina:any
  ) {
    let valorDescuento = 0
    // Verificar si el descuento es un número válido
    let valorDescuentoNumerico = Number(descuento);
    if (!isNaN(valorDescuentoNumerico) && valorDescuentoNumerico > 0) {
      valorDescuento = valorDescuentoNumerico
    }
    let valorDeLaPropina = []

    if (tipoPropina === 'valor') {
      console.log('La propina es un valor fijo:', propinaValor);
      if(propinaValor === undefined) {
        this.utils.mensajeMuestro('Pago', 'No a ingresado un valor para incluir en el servicio, por favor verifique...', 'warning');
        return;
      }
      valorDeLaPropina.push({
        tipo: tipoPropina,
        valor: propinaValor
      })
    } else if (tipoPropina === 'porcentaje') {
      console.log('La propina es un porcentaje:', propinaPorcentaje);
      if(propinaPorcentaje === undefined) {
        this.utils.mensajeMuestro('Pago', 'No a ingresado un porcentaje para incluir en el servicio, por favor verifique...', 'warning');
        return;
      }
      valorDeLaPropina.push({
        tipo: tipoPropina,
        valor: propinaPorcentaje
      })
    }


    const valorRaw = this.valorPago[group];
    // Verifica si el valor es una cadena antes de llamar a `replace`
    if (typeof valorRaw === 'string') {
      const valor = parseFloat(valorRaw.replace(/,/g, ''));

      if (isNaN(valor)) {
        console.log('El valor ingresado no es válido.');
        return;
      }

      let lista = producto[group]

      let formasDePago = this.formaDePagosFiltrada.filter(item => item !== null);
      let valorDevolver = 0
      if(valorDescuento > 0) {
        valorDevolver = valorDescuento
      } else {
        valorDevolver = this.totals[Number(group)]
      }
      let valorPago = ''
      if (valorRaw.includes(',')) {
        valorPago = valorRaw.replace(/,/g, '');
      }
      let valorPagoReal = 0

      // Si tiene más de un punto, es un formato inválido, pero si solo tiene uno, es un número decimal
      if ((valorRaw.match(/\./g) || []).length > 1) {
          console.log("El formato del número es inválido.");
      } else {
        valorPagoReal = Number(valorRaw);
          if (isNaN(valorPagoReal)) {
              console.log("El valor no es un número válido.");
          } else {
              console.log("El valor numérico es:", valorPagoReal);
          }
      }

      if (valorPagoReal < valorDevolver) {
        this.utils.mensajeMuestro('Pago', 'El valor pagado es menor al valor de la venta, por favor verifique...', 'warning');
        return;  // Salir de la función si el valor no es válido
      }
        let valorTotalDevolverU = Number(valorPagoReal)
        let valorPagadoU = Number(valorDevolver)
        this.datosAdicionales['valorTotalDevolver'] =   Number(valorTotalDevolverU) - Number(valorPagadoU)
        this.datosAdicionales['valorTotalVenta'] = valorPagadoU > 0 ? valorPagadoU : valorPagadoU //datosAdicionales.valorTotalVenta;
        this.datosAdicionales['totalPagado'] =Number(valorTotalDevolverU)
        this.generarPago(this.groupedProducts,
          lista,
          this.totals,
          formasDePago,this.datosAdicionales['valorTotalDevolver'],
          this.datosAdicionales['totalPagado'],
          formasDePago,
          devolver,
          this.datosAdicionales,
          group,
          valorDescuento,
          valorDeLaPropina
        )
        this.valorPago[group] = '';
        // Lógica para procesar el pago
    } else if (typeof valorRaw === 'number') {
      console.log('Valor a pagar:', valorRaw);
      // Lógica para procesar el pago
    } else {
      console.error('El valor ingresado no es válido.');
    }
  }

  calcularDevolucion(total: number, valorPagado: any, descuento: any): number {
    const valorPago = parseFloat(valorPagado.replace(/,/g, '')); // Convierte a número
    if (isNaN(valorPago)) {
        return 0; // Retorna 0 si el valor es inválido
    }

    // Verificar si el descuento es un número válido
    const valorDescuento = Number(descuento);
    if (!isNaN(valorDescuento) && valorDescuento > 0) {
        // Si el descuento es válido, usarlo para calcular la devolución
        return valorPago - valorDescuento;
    }

    // Si el descuento no es válido, usar el total original
    return valorPago - total;
}

  async generarPago(groupedProducts:any,productos:any,
    totals:any,formasDePago:any,valorTotalDevolver:any,
    valorPagado:any,formasDePagoGeneral:any,
    devolver:any=0,
    datosAdicionales:any,
    group:any,
    valorDescuento:Number =0,
    valorDeLaPropina:any
  ) {
    this.groupedProducts = groupedProducts
    this.totals = totals
    this.formasDePagoGeneral = formasDePago !== undefined &&
    formasDePago[0] !== undefined && formasDePago[0].length > 0 ? formasDePago[0] : formasDePago
    await this.servicio.pagarMesas(
      productos, formasDePago,valorTotalDevolver,valorPagado,
      formasDePagoGeneral, valorPagado, formasDePago, this.CheckPorcentajeServicio,this.turnosArray, this.listaProductosSeleccionados,this.mesaSeleccionada, this.deseaImprimir,
      devolver,datosAdicionales,valorDescuento,valorDeLaPropina)
      this.productos = this.productos.filter(prod =>
        !productos.some(otro => otro.comandasId === prod.comandasId)
    );
    this.cargarFormasDePago()
    this.calcularValorTotalVenta()
    const groupKey = parseInt(group);

    // Eliminar el grupo con la clave correspondiente
    delete this.groupedProducts[groupKey];
}


async traerIdDelTurno(turnoId: string, companiasId: string) {
  let turno = turnoId;
  try {
    let val: any = await this.servicio.buscarComandasturnoPorCompania(turno, companiasId).toPromise();

    this.listaProductosSeleccionados = [];
    let entrarDatos = false;
    let dataJson = JSON.parse(val['_body']);
    let dataResponse = dataJson.data;
    val = dataResponse;

    if (val.length > 0 && val[0].length > 0) {


      for (let k = 0; k < val[0].length; k++) {
        this.listaProductosSeleccionados.push(val[0][k]);
        this.valorTotalVenta += Number(val[0][k].valorTotalVenta);
        this.listaProductosSeleccionados[k]['valorImpuesto'] += k == 0 ? 0 : Number(val[0][k]['valorImpuestosIndividual']);
        this.listaProductosSeleccionados[k]['valorProducto'] += k == 0 ? 0 : Number(val[0][k]['valorProductoIndividual']);
        this.listaProductosSeleccionados[k]['domicilio'] = val[0][k].domicilio;
        this.listaProductosSeleccionados[k]['formaDePago'] = val[0][k].formaDePago;
        this.listaProductosSeleccionados[k]['incluirServicio'] = val[0][k].incluirServicio;
        this.datosAdicionales = {
          valorTotalVenta: this.valorTotalVenta,
          totalPagado: this.valorTotalVenta,
          valorTotalDevolver: 0,
          usuariosId: val[0][k].usuariosId,
          companiasId: val[0][k].companiasId,
          clientesId: val[0][k].clientesId,
          turno: val[0][k].turno,
          comandasId: val[0][k].comandasId
        };
      }
      entrarDatos = true;
    }
  } catch (error) {
    console.log('Error al traer los datos del turno', error);
  }

}

calcularTotalConPropina(group: string, tipo: string) {
  let totalBase = this.totalConDescuento[group] || this.totals[group];

  if (tipo === 'porcentaje') {
    let porcentaje = Number(this.propinaPorcentaje[group]) || 0;
    let propina = (porcentaje > 0) ? (totalBase * porcentaje) / 100 : 0;
    this.totalConPropina[group] = totalBase + propina;
  } else if (tipo === 'valor') {
    let propina = Number(this.propinaValor[group]) || 0;
    this.totalConPropina[group] = totalBase + propina;
  } else {
    this.totalConPropina[group] = totalBase;
  }
  // Asegurar que actualizamos el total global sin generar un bucle infinito
  this.actualizarTotalVenta();
}

// Función separada para actualizar el total general
actualizarTotalVenta(): void {
  let totalVenta = 0;

  for (const group in this.totalConPropina) {
    totalVenta += Number(this.totalConPropina[group]) || 0;
  }

  this.valorTotalVenta = totalVenta;
}

calcularDevolucionPropina(totalConPropina: number, valorPago: number): number {
  console.log('totalConPropina:', totalConPropina, 'valorPago:', valorPago);  // Agregar log para ver los valores
  // Asegurarnos de que los valores sean números válidos
  const totalConPropinaNum = Number(totalConPropina);
  const valorPagoNum = Number(valorPago);

  if (valorPagoNum > totalConPropinaNum) {
    return valorPagoNum - totalConPropinaNum;
  } else {
    return 0;
  }
}
// Método para reiniciar valores si el usuario cambia de opinión sobre la propina
reiniciarPropina(group: string) {
  if (this.deseaPropina[group] === 'no') {
    this.tipoPropina[group] = '';
    this.propinaPorcentaje[group] = 0;
    this.propinaValor[group] = 0;
    this.totalConPropina[group] = this.totalConDescuento[group] || this.totals[group];
  }
}

}

interface FormaPago {
  codigoFormaPago: string;
  nombreFormaPago: string;
  imagen: string;
  valor: number;
  formattedValor?: string;
}





// WEBPACK FOOTER //
// ./src/pages/personalizar/personalizar.ts